export const HOME_PAGE = '/'
export const SERVICES_PAGE = '/services'
export const PAYMENT_PAGE = '/payment'
export const RESERVATIONS_PAGE = '/reservations/:id'
export const OFFER_PAGE = '/offer/:offerId/:bookingId'
export const OFFER_PAYMENT_PAGE = '/offer/:offerId/:bookingId/payment'
export const GUEST_REGISTRATION_PAGE = '/reservation/check-in/:reservationUuid'
